<template>
  <div>
    <tool-bar :title="title" subTitle=""></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item :show="!showRefreshItem"></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div v-if="showUI" class="margin_top_40">
      <div class="margin-left-10 margin-right-10">
        <weex-text class="item-heading" v-html="customerTasksCompletedInstructions"></weex-text>
      </div>

      <wxc-button
        text="Continue"
        class="button_horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import StageCommentItem from "../../layout/StageCommentItem";
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import { Activities } from "../../../utils/ActivityNavigator";
import LoanTasksActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import RefreshItem from "../../layout/RefreshItem";
import DataSource from "../../../data/DataSource";

export default {
  name: "CustomerTasksCompletedActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    ToolBar,
    WxcButton,
    StageCommentItem,
    RefreshItem
  },
  data: () => ({
    title: "Customer Tasks Completed",
    showUI: false,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    customerTasksCompletedInstructions: "",
    showRefreshItem: false
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onSubmit() {
      this.completeCurrentTaskAndGetNextTask();
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(
        this.tasks,
        false,
        LoanScopeDataHolder.getRedirectUrl()
      )
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        })
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(stageConfigDataRes => {
          this.loading = false;
          if (stageConfigDataRes.errorOccurred) {
            this.showError(stageConfigDataRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            const stageConfigData = stageConfigDataRes.data;
            this.customerTasksCompletedInstructions = stageConfigData && stageConfigData.properties
              ? stageConfigData.properties["stage.instructions"]
              : "";
          }
        })
    }
  },

  created: function () {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.CUSTOMER_TASKS_COMPLETED];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    }
  }
}
</script>

<style scoped src="../../../assets/style/base.css"></style>
